/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MarkBankTransferTransactionAsPaidRequest } from '../../models/mark-bank-transfer-transaction-as-paid-request';

export interface MarkBankTransferTransactionPaid$Params {
  id: number;
      body: MarkBankTransferTransactionAsPaidRequest
}

export function markBankTransferTransactionPaid(http: HttpClient, rootUrl: string, params: MarkBankTransferTransactionPaid$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, markBankTransferTransactionPaid.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

markBankTransferTransactionPaid.PATH = '/api/payment/{id}/mark-paid';
